import * as React from 'react'
import { default as Button } from '@mulesoft/anypoint-components/lib/Button';
import { WrongBusinessGroupSvg } from './WrongBusinessGroupSvg'
import { EmptyStatePageState } from './model'
import { NotFoundSvg } from './NotFoundSvg'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import './EmptyStatePage.css'

export type ValueProps = EmptyStatePageState

export type EventProps = {
  handleRedirection?: (href?: string) => void
}

export type Props = ValueProps & EventProps

export const EmptyStatePage = (props: Props) => {
  const onClickButton = () => props.handleRedirection && props.handleRedirection(props.redirectLink && props.redirectLink.href)

  return (
    <div className={'landing-page-empty-state-container'}>
      <div className={'landing-page-empty-state-wrapper'}>
        <div className={'landing-page-empty-state-header'}/>
        <div className={'landing-page-empty-state-body'}>
          <div className={'landing-image'}>
            {props.is404 ? <NotFoundSvg/> : <WrongBusinessGroupSvg/>}
          </div>

          <div className={'landing-page-empty-state-body-info'}>
            <span className={'landing-page-empty-state-title'}>{props.emptyStateTitle}</span>
            {props.emptyStateSubtitle && <span className={'landing-page-empty-state-subtitle'}>{props.emptyStateSubtitle}</span>}
            { props.redirectLink &&
            <Button
              className={'landing-page-empty-state-button'}
              kind={'primary'}
              testId={'landing-page-empty-state-button'}
              onClick={onClickButton}
            >
              <IconPanel testId={'empty-state-back-icon'} name={'back-small'} size={'xs'}/>
              {props.redirectLink.label}
            </Button>
            }
          </div>
        </div>
        <div className={'landing-page-empty-state-footer'}>
          <a data-test-id="empty-state-documentation-link" href={'https://docs.mulesoft.com/monitoring/'}>
            <IconPanel testId={'empty-state-documentation-icon'} name={'documentation-small'} size={14}/>
            <span>Visit Anypoint Monitoring documentation</span>
          </a>
        </div>
      </div>
    </div>
  )
}
